import { getSessionToken } from '@shopify/app-bridge-utils'

window.getSessionToken = getSessionToken;